export default __webpack_public_path__ + "static/media/ico_email.e343ce61.svg";